export default "__VITE_ASSET__DG0j6rQs__"